export default __webpack_public_path__ + "static/media/githubLogo.519d376e.png";